import { GalleryInterface } from "@ihr-radioedit/inferno-core";
import { galleryToAssetLegacy } from "../lib/gallery-helpers";
import { AssetLegacy } from "./AssetLegacy.component";
import "./Gallery.style.scss";

export const Gallery = (props: GalleryInterface) => {
  return (
    <ul className="component-gallery" data-total={props.value.length}>
      {props.value.map((item, index) => (
        <li key={index}>
          <AssetLegacy {...galleryToAssetLegacy(item, index + 1, props.value.length)} />
        </li>
      ))}
    </ul>
  );
};

export default Gallery;
